import { defer } from 'rxjs';
import http from '../network/http';

export function getAllCategory() {
  return defer(() => http.get('/v1/category/find'));
}
